import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import CKEDITOR from '@workboard/ckeditor5-build-wobo';

import { useOnClickOutside } from '../hooks/useOnClickOutside';

const editorConfiguration = {
    toolbar: [
        'fontColor',
        'bold',
        'italic',
        'underline',
        'strikethrough',
        'numberedList',
        'bulletedList',
        'outdent',
        'indent',
        'alignment:left',
        'alignment:center',
        'alignment:right',
        'link',
        'horizontalLine',
        'fontSize',
        '|',
        'heading'
    ],
    indent: {
        offset: 1,
        unit: 'em'
    },
    outdent: {
        offset: 1,
        unit: 'em'
    },
    heading: {
        options: [
            {
                model: 'paragraph', view: 'p', title: 'Paragraph',
            },
            {
                model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1'
            },
            {
                model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2'
            },
            {
                model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3'
            },
            {
                model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4'
            },
            {
                model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5'
            },
            {
                model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6'
            }
        ]
    },
    fontSize: {
        options: ['default', 8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28]
    },
    table: {
        contentToolbar: [
            'tableColumn',
            'tableRow',
            'tableDefault',
            'tableCellProperties',
        ],
    },
    isReadOnly: false
};

const CKEditorComponent = ({ onClickOutside, data, elementId }) => {
    const [editorData, setEditorData] = React.useState(data);
    const [inputRef] = useOnClickOutside(() => {
        /*
            Clicking the "link" button on ckeditor causes blur event, so have to use click outside.
            When the link form is opened and you click inside it, it causes the click
            outside of ckeditor wrapper, which saves the current data, closes the ckeditor and umnounts
            the component. The following check is necessary to prevent this kind of behaviour
        */
        const isOpenLinkForm = document.querySelector('.ck-balloon-panel')?.classList.contains('ck-balloon-panel_visible');

        if (isOpenLinkForm) {
            return;
        }
        onClickOutside(editorData);
        ReactDOM.unmountComponentAtNode(document.getElementById(elementId));
    });
    const handleReady = (editor) => {
        editor.editing.view.change((writer) => {
            writer.setStyle({
                'min-height': '100px'
            }, editor.editing.view.document.getRoot());
        });
        editor.editing.view.focus();
    };

    const onChange = (_, editor) => {
        setEditorData(editor.getData());
    };

    useEffect(() => {
        window.dispatchEvent(new CustomEvent('resize'));
    }, [editorData]);

    return (
        <div ref={inputRef}>
            <CKEditor
                editor={CKEDITOR.ClassicEditor}
                config={{
                    licenseKey: ckeditorLicenseKey,
                    ...editorConfiguration,
                }}
                onReady={handleReady}
                data={editorData}
                onChange={onChange}
            />
        </div>
    );
}

function initObjectiveCkeditor (elementId, editorValue, onClickOutside) {
    ReactDOM.render(
        <CKEditorComponent
            onClickOutside={onClickOutside}
            elementId={elementId}
            data={editorValue}
        />,
        document.getElementById(elementId)
    );
}

window.initObjectiveCkeditor = initObjectiveCkeditor;
